/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023-2025 (original work) Open Assessment Technologies SA ;
 */
export const INPUT_DEBOUNCE = 500;
export const SEARCH_CHARACTERS_LIMIT = 100;
export const PAGINATION_PAGE_SIZE = 20;

export const CELL_DISPLAYED_LIST_ITEM_COUNT = 3;

export const TASK_ORCHESTRATOR_JOB = {
    TYPES: {
        CSV_EXPORT: 'csvExport',
        CSV_IMPORT: 'csvImport',
        TEST_PUBLICATION: 'testPublication',
        AI_CONVERSION: 'aiConversion',
        AI_DOCUMENT: 'aiDocument',
        AI_SCORE_SUGGESTION: 'aiScoreSuggestion',
        PDF_EXPORT: 'pdfExport'
    },
    STATUSES: {
        FINISHED: 'finished',
        FAILED: 'failed'
    }
};

export const CONTENT_MODES = {
    DELIVERY: 'delivery',
    BATTERY: 'battery'
};

export const supportTabs = {
    LIVE_ACTIVITY: 'live-activity',
    ACTIVITY_LOGS: 'activity-logs',
    PROCTORING_LOGS: 'proctoring-logs',
    USER_SESSIONS: 'user-sessions',
    DELIVERY_EXECUTIONS: 'delivery-executions',
    TEST_RESULTS: 'test-results',
    PASSWORD: 'password'
};
